import React, { Component } from "react";
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import moment from "moment";
import Autocomplete from "react-autocomplete";
import { addOPA, getOPAActivity } from "../../../../actions/OPAAction";
import $ from 'jquery';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import { getSettingsFormat } from "../../../../actions/SettingsAction";
import dateFormat from 'dateformat'
import { getlookupdocinfo } from "../../../../actions/MasterDataAction";
import del from "../../../../assets/img/svg/Del.svg";

class AddOPA extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            isError: false,
            ActivityError: false,
            PlannedDateError: false,
            ReasonsForDeviationError: false,
            cancel: false,
            addData: {
                "OperationPlanId": 0,
                "ProjectId": 0,
                "PlannedDate": "",
                "Activity": "",
                "CompletionDate": null,
                "ReasonsForDeviation": "",
                "ModifiedBy": ""
            }
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.state.addData.ModifiedBy = localStorage.getItem("UserRoles");
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"))
        this.setState({})
        dispatch(getlookupdocinfo("Operation"))
        this.props.dispatch(getSettingsFormat(this.state.addData.ProjectId))
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#Operation1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Operation").addClass("d-none");
        $("#Operation").removeClass("d-block");
        $("#OPAL").removeClass("active-color");
        $("#OPAT").removeClass("fw-bolder");
    }
    AddSave = () => {
        const { dispatch } = this.props;
        const { Activity, PlannedDate, ReasonsForDeviation, CompletionDate } = this.state.addData;

        if (Activity.trim() === "") {
            this.state.ActivityError = true;
            this.state.addData.Activity = this.state.addData.Activity.trim();
            this.setState({})
        }
        else {
            this.state.ActivityError = false;
            this.state.addData.Activity = this.state.addData.Activity.trim();
            this.setState({})
        }

        if (PlannedDate === "") {
            this.state.PlannedDateError = true;
            this.setState({})
        }
        else {
            this.state.PlannedDateError = false;
            this.setState({})
        }
        if (CompletionDate !== null) {
            if (ReasonsForDeviation.trim() === "") {
                this.state.ReasonsForDeviationError = true;
                this.state.addData.ReasonsForDeviation = this.state.addData.ReasonsForDeviation.trim();
                this.setState({})
            }
            else {
                this.state.ReasonsForDeviationError = false;
                this.state.addData.ReasonsForDeviation = this.state.addData.ReasonsForDeviation.trim();
                this.setState({})
            }
        }
        if (this.state.addData.Activity !== "" && PlannedDate !== '' && (!CompletionDate || (CompletionDate && this.state.ReasonsForDeviationError == false))) {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.addOPA(this.state.addData)
        }
    }
    addOPA = (data) => {
        let apiUrl = API.OPA_LISTVIEW;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/operationplanningachievements")
                    //dispatch({ type: "OPA_Add", data: response.data })
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebar");
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebar");
    }
    handleProjectNameSearchChange = (e) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData.Activity = e.target.value;
        this.setState({});
    };
    renderProjectNames = (state, val) => {
        return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };
    handleProjectNameSelectChange = (e) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData.Activity = e;
        this.setState({});
    };
    handleInputChange = (e, node) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData[node] = e.target.value;
        this.setState({});
    };
    handleCommentChange = (e, node) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        if (e.target.value.length - 1 < 500) {
            this.state.addData[node] = e.target.value;
            this.setState({});
        }
    };

    handleDateChange = (e, node) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData[node] = e.target.value;
        this.setState({});
    };

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        // $("#OPE1 .MuiListItemText-primary").addClass("spanTopBar");
        // $("#Operation1 .MuiListItemText-primary").addClass("fw-bolder");
        // $("#Operation").removeClass("d-none");
        // $("#Operation").addClass("d-block");
        // $("#OPAL").addClass("active-color");
        // $("#OPAT").addClass("fw-bolder");
    };

    resize1 = () => {
        $("#OPE1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Operation1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Operation").removeClass("d-none");
        $("#Operation").addClass("d-block");
        $("#OPAL").addClass("active-color");
        $("#OPAT").addClass("fw-bolder");
    };

    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/operationplanningachievements`)
        }
    }
    AddCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate("/operationplanningachievements")
    };
    render() {
        let { classes, menuToggle, OPA_Add, OPA_Actvity } = this.props;

        return (
            <> {
                this.state.isMobile ?
                    <>
                        <div className="row w-100 mt-4">
                            <div className="col-6 mt-auto" >
                                <List className="pt-3  mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                    <ListItem onClick={this.sidebar} >
                                        <ListItemText id={"OPE" + "1"} className=' textNaviIcon' primary="Daily Tasks" />
                                        <NavigateNextIcon id="OPE" className="naviIcon ml-auto" style={{ width: 23, height: 23 }} />
                                        <Divider className='border-bottom' />
                                    </ListItem>
                                </List>
                            </div>
                            <div className="col-6 pt-2 mt-5">
                                <h4>Add New Operation Planning & Achievement</h4>
                            </div>
                        </div>
                    </>
                    :
                    <></>
            }
                <div className="ml-auto" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                <td className="border-right text-center"><i className="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                <td className="border-right text-center">
                                    <button className={classes.button} onClick={this.AddSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                </td>
                                <td className="text-center">
                                    <button className={classes.button} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                        :
                        <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center">
                                        <i className="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                    <td width="95%">
                                        <button className={classes.button} onClick={this.AddSave} ><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        <button className={`${classes.button} pl-3`} onClick={this.AddCancel1} ><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    }
                    <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        {this.state.isMobile ? "" : <h6 className="col-12 mx-2 pt-2 ml-1">Add New Operation Planning & Achievement</h6>}
                        <div className={this.state.isMobile ? "row mt-1 mx-0 pr-2 pt-1" : "row mt-1 mx-3 pr-2 pt-1"}>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end text-right d-flex m-0"}>Activity&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {this.state.ActivityError ?
                                        <div className="autocomplete-wrappers">
                                            <Autocomplete
                                                contentEditable={true}
                                                value={this.state.addData.Activity}
                                                inputProps={{
                                                    placeholder: "Activity",
                                                }}
                                                items={OPA_Actvity ?? []}
                                                getItemValue={(item) => item.Name}
                                                shouldItemRender={this.renderProjectNames.bind(this)}
                                                renderMenu={(item) => (
                                                    <div className="dropdowns d-block" >{item}</div>
                                                )}
                                                renderInput={(props) => {
                                                    return (
                                                        <input
                                                            className="form-control border-radius"
                                                            id="exampleFormControlInput1"
                                                            {...props}
                                                            style={{ height: 32, fontSize: 12, color: "#000000", borderColor: 'red' }}
                                                        />
                                                    );
                                                }}
                                                renderItem={(item, isHighlighted) => (
                                                    <div
                                                        className={`items 
                                          ${isHighlighted ? "selected-items" : ""
                                                            }`}
                                                    >
                                                        {item.Name}
                                                    </div>
                                                )}
                                                onChange={(e) => this.handleProjectNameSearchChange(e)}
                                                onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                            />

                                        </div> :
                                        <div className=" autocomplete-wrappers">
                                            <Autocomplete
                                                contentEditable={true}
                                                value={this.state.addData.Activity}
                                                inputProps={{
                                                    placeholder: "Activity",
                                                }}

                                                items={OPA_Actvity ?? []}
                                                getItemValue={(item) => item.Name}
                                                shouldItemRender={this.renderProjectNames.bind(this)}
                                                renderMenu={(item) => (
                                                    <div className="dropdowns d-block" >{item}</div>
                                                )}
                                                renderInput={(props) => {
                                                    return (
                                                        <input
                                                            className="form-control border-radius"
                                                            id="exampleFormControlInput1"
                                                            {...props}
                                                            style={{ width: '100%', height: 35, fontSize: 12, color: "#000000" }}
                                                        />
                                                    );
                                                }}
                                                renderItem={(item, isHighlighted) => (
                                                    <div
                                                        className={`items 
                         ${isHighlighted ? "selected-items" : ""
                                                            }`}
                                                    >
                                                        {item.Name}
                                                    </div>
                                                )}
                                                onChange={(e) => this.handleProjectNameSearchChange(e)}
                                                onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                            />

                                        </div>

                                    }
                                </div>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end text-right d-flex m-0"}>Planned Date&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {this.state.PlannedDateError ?
                                        <TextField
                                            type="date"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            id="type-date"
                                            value={this.state.addData.PlannedDate && moment(this.state.addData.PlannedDate).format("yyyy-MM-DD")}
                                            placeholder={this.state.addData.PlannedDate && moment(this.state.addData.PlannedDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleDateChange(e, "PlannedDate") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                            }}
                                            inputProps={{
                                                max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                              }}
                                        />
                                        :
                                        <TextField
                                            type="date"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            id="type-date"
                                            value={this.state.addData.PlannedDate && moment(this.state.addData.PlannedDate).format("yyyy-MM-DD")}
                                            placeholder={this.state.addData.PlannedDate && moment(this.state.addData.PlannedDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleDateChange(e, "PlannedDate") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            inputProps={{
                                                max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                              }}
                                        />
                                    }
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "pt-2" : "text-right m-0"}>Date of Completion&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        type="date"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        id="type-date"
                                        value={this.state.addData.CompletionDate && moment(this.state.addData.CompletionDate).format("yyyy-MM-DD")}
                                        placeholder={this.state.addData.CompletionDate && moment(this.state.addData.CompletionDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                        onChange={(e) => { this.handleDateChange(e, "CompletionDate") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                        }}
                                        inputProps={{
                                            max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                            min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                          }}
                                    />
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : this.state.addData.CompletionDate == null ? "mt-n4 col-md-2" : " mt-n4 col-md-2 px-0"}`}>
                                    {this.state.addData.CompletionDate == null ? <>
                                        <label className={this.state.isMobile ? "pt-2" : "text-right m-0"}>Reasons for Deviation&nbsp;:</label>
                                    </>
                                        :
                                        <><label className={this.state.isMobile ? "d-flex pt-2" : "text-right float-end d-flex m-0"}>Reasons for Deviation&nbsp;:
                                            <div className={`${classes.helperText}`}>
                                                <div className="MuiFormHelperText-contained">*</div>
                                            </div></label></>}
                                </div>
                                <div className={`col-12 col-sm-12 col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                    {this.state.ReasonsForDeviationError ?
                                        <TextField
                                            multiline
                                            rows={4}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.ReasonsForDeviation}
                                            onChange={(e) => { this.handleCommentChange(e, "ReasonsForDeviation") }}
                                            error
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        /> :
                                        <TextField
                                            multiline
                                            rows={4}
                                            variant="outlined"
                                            size="small"
                                            value={this.state.addData.ReasonsForDeviation}
                                            onChange={(e) => { this.handleCommentChange(e, "ReasonsForDeviation") }}
                                            fullWidth
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                    <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.ReasonsForDeviation?.length == undefined ? 500 - 0 : 500 - this.state.addData?.ReasonsForDeviation?.length}/500 Characters left</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal fade p-5 mt-5" id="cancelpopup" tabIndex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div className="modal-dialog" role="document">
                            <div className={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div className="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 className="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div className="modal-footer border-top-0 m-auto">
                                    <button type="button" className={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.AddCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" className={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        OPA_Add: state.OPAReducer.OPA_Add || [],
        OPA_Actvity: state.MasterDataReducer.Lookup_data || [],
        settings: state.commonReducer.settings || [],
    };
}

AddOPA.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddOPA))
);

